import React from 'react';
import { NavItem } from './nav-item.component';

import styles from './nav-items.styles.css';

export const NavItems = ({ items }) => (
  <ul className={styles.navList}>
    {items.map(navItem => (
      <NavItem key={navItem.id} navItem={navItem} />
    ))}
  </ul>
);
